exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2-ZL0JUhEcuafN{position:relative;overflow-y:auto;outline:none;display:flex;flex-direction:column;flex-grow:1}", ""]);

// exports
exports.locals = {
	"popoverBoundary": "_2-ZL0JUhEcuafN"
};